// @flow
import * as React from 'react';
import styled from 'styled-components';
import DevFlag from 'common/components/DevFlag';
import SalesPromotionBanners from './SalesPromotionBanners';

const Wrapper = styled.div`
  flex: 1;
`;

const withSalesPromotionBanners = (Component: any) => {
  return (props: any) => (
    <Wrapper>
      <DevFlag flag="SALES_PROMOTIONS">
        <SalesPromotionBanners />
      </DevFlag>
      <Component {...props} />
    </Wrapper>
  );
};

export default withSalesPromotionBanners;



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/withSalesPromotionBanners.js